import { TrendingUp, TrendingDown } from 'lucide-react';

function MetricCard({ 
  title, 
  value, 
  icon, 
  status = 'neutral', 
  trend = null, 
  description = '',
  onClick = null 
}) {
  // Status color mapping
  const getStatusColors = (status) => {
    switch (status) {
      case 'healthy':
        return {
          border: '#22c55e',
          iconColor: '#22c55e',
          accent: 'rgba(34, 197, 94, 0.1)'
        };
      case 'warning':
        return {
          border: '#f59e0b',
          iconColor: '#f59e0b',
          accent: 'rgba(245, 158, 11, 0.1)'
        };
      case 'critical':
        return {
          border: '#ef4444',
          iconColor: '#ef4444',
          accent: 'rgba(239, 68, 68, 0.1)'
        };
      default:
        return {
          border: 'var(--border)',
          iconColor: 'var(--primary)',
          accent: 'transparent'
        };
    }
  };

  const colors = getStatusColors(status);

  // Trend indicator
  const renderTrend = () => {
    if (!trend) return null;

    const isPositive = trend.direction === 'up';
    const TrendIcon = isPositive ? TrendingUp : TrendingDown;
    const trendColor = isPositive ? '#22c55e' : '#ef4444';

    return (
      <div className="flex items-center gap-1 mt-2">
        <TrendIcon className="w-4 h-4" style={{ color: trendColor }} />
        <span 
          className="text-sm font-medium"
          style={{ color: trendColor }}
        >
          {trend.value}
        </span>
        <span className="text-xs" style={{ color: 'var(--muted)' }}>
          {trend.period}
        </span>
      </div>
    );
  };

  return (
    <div
      className={`rounded-xl p-6 border transition-all duration-200 ${
        onClick ? 'cursor-pointer hover:shadow-md' : ''
      }`}
      style={{ 
        background: 'var(--panel)',
        borderColor: colors.border,
        boxShadow: status !== 'neutral' ? `0 0 0 1px ${colors.accent}` : undefined
      }}
      onClick={onClick}
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h3 
          className="text-sm font-medium truncate"
          style={{ color: 'var(--muted)' }}
          title={title}
        >
          {title}
        </h3>
        <div 
          className="p-2 rounded-lg"
          style={{ 
            background: colors.accent,
            color: colors.iconColor 
          }}
        >
          {icon}
        </div>
      </div>

      {/* Value */}
      <div className="mb-2">
        <div 
          className="text-2xl font-bold truncate"
          style={{ color: 'var(--text)' }}
          title={value}
        >
          {value}
        </div>
        {renderTrend()}
      </div>

      {/* Description */}
      {description && (
        <p 
          className="text-xs leading-relaxed"
          style={{ color: 'var(--muted)' }}
        >
          {description}
        </p>
      )}

      {/* Status indicator */}
      {status !== 'neutral' && (
        <div className="mt-3 pt-3 border-t" style={{ borderColor: 'var(--border)' }}>
          <div className="flex items-center gap-2">
            <div 
              className="w-2 h-2 rounded-full"
              style={{ background: colors.iconColor }}
            />
            <span 
              className="text-xs font-medium capitalize"
              style={{ color: colors.iconColor }}
            >
              {status}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default MetricCard;